<template lang="pug">
b-modal#icModal.modal.fade(
  size="lg",
  centered,
  hide-footer="",
  tabindex="-1",
  aria-labelledby="icModal",
  aria-hidden="true"
)
  .row.mb-3
    .col-md-4
      img.w-100(
        v-if="product.photos && product.photos.length > 0",
        :src="product.photos[0].image"
      )
    .col-md-8
      h4 {{ product.name }}
      h5 HardWare Specification
      table.table.table-bordered.table-sm
        tbody
          tr(v-for="item in product.popup_data")
            th {{ item.name }}
            td {{ item.value }}
  h5(v-if="product.features && product.features.length > 0") Features :
  ul
    li(v-for="(feature, index) in product.features", :key="index") {{ feature.name }}

  //- From Jesse (20230614): 目前產品跳出視窗內的3個按鍵功能有限, 因我們暫時不提供Datasheet下載
  //- 暫時把3個按鍵移除, 使用者還是可以透過Menu去留言及下載Driver
  //- .row.mt-4
  //-   .col-lg-4.mb-2
  //-     .btn.btn-primary.btn-block(@click="dataSheetClick") DataSheet
  //-   .col-lg-4.mb-2
  //-     .btn.btn-primary.btn-block(@click="driverClick") Driver
  //-   .col-lg-4
  //-     .btn.btn-primary.btn-block(@click="inquiryClick") Inquiry

  //- From Angus (20240129): DataSheet 資料以上傳，先將 DataSheet 以及 Inquiry 加回來
  .row.mt-4.justify-content-center
    .col-lg-4.mb-2
      .btn.btn-primary.btn-block(@click="dataSheetClick") DataSheet
    .col-lg-4
      .btn.btn-primary.btn-block(@click="inquiryClick") Inquiry
</template>

<script>
export default {
  name: "DialogProductIC",
  props: {
    product: Object,
  },
  methods: {
    dataSheetClick() {
      this.$router.push({
        name: "Download",
        params: {
          type: "DATA_SHEET",
          id: 0,
        },
      });
    },
    driverClick() {
      this.$router.push({
        name: "Download",
        params: {
          type: "DRIVER",
          id: 0,
        },
      });
    },
    inquiryClick() {
      this.$router.push({ name: "ContactUs" });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/common/table";

th,
td {
  width: 50%;
}

::v-deep .modal-header {
  border: 0;
  padding-bottom: 0;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
